import { useEffect } from 'react';
import { Link } from 'react-router-dom';

function LegalLayout({
	title,
	description,
	children,
	updatedAt,
	sections = [],
}) {
	useEffect(() => {
		window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
	}, []);

	return (
		<main className='min-h-screen bg-[radial-gradient(circle_at_top,_rgba(255,255,255,0.08),_transparent_45%),linear-gradient(180deg,#050505_0%,#090909_100%)] px-6 py-14 text-primary lg:px-10 lg:py-20'>
			<div className='mx-auto w-full max-w-6xl'>
				<div className='mb-8 flex flex-wrap items-center justify-between gap-4'>
					<Link
						to='/'
						className='inline-flex min-h-11 items-center rounded-full border border-white/15 px-5 text-sm text-primary/75 transition-colors hover:text-primary focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary/70'
					>
						← Volver al inicio
					</Link>

					<div className='flex flex-wrap gap-2'>
						<Link
							to='/privacidad'
							className='inline-flex min-h-11 items-center rounded-full border border-white/15 px-4 text-xs font-semibold uppercase tracking-[0.16em] text-primary/70 transition-colors hover:text-primary focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary/70'
						>
							Politica de privacidad
						</Link>
						<Link
							to='/terminos'
							className='inline-flex min-h-11 items-center rounded-full border border-white/15 px-4 text-xs font-semibold uppercase tracking-[0.16em] text-primary/70 transition-colors hover:text-primary focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary/70'
						>
							Terminos y condiciones
						</Link>
					</div>
				</div>

				<div className='grid gap-7 lg:grid-cols-[240px_minmax(0,1fr)]'>
					<aside className='lg:sticky lg:top-24 lg:h-fit'>
						<div className='rounded-2xl border border-white/10 bg-white/[0.04] p-5'>
							<p className='mb-4 text-[10px] font-bold uppercase tracking-[0.24em] text-primary/45'>
								En esta pagina
							</p>
							<nav className='space-y-1.5'>
								{sections.map(section => (
									<a
										key={section.id}
										href={`#${section.id}`}
										className='block rounded-lg px-3 py-2 text-sm text-primary/75 transition-colors hover:bg-white/5 hover:text-primary focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary/70'
									>
										{section.label}
									</a>
								))}
							</nav>
						</div>
					</aside>

					<article className='rounded-2xl border border-white/10 bg-white/[0.03] p-7 backdrop-blur sm:p-10'>
						<div className='mb-8 flex flex-wrap items-center gap-3'>
							<span className='inline-flex min-h-9 items-center rounded-full border border-white/15 px-4 text-[10px] font-bold uppercase tracking-[0.22em] text-primary/55'>
								Documento legal
							</span>
							<span className='inline-flex min-h-9 items-center rounded-full border border-white/15 px-4 text-[10px] font-bold uppercase tracking-[0.2em] text-primary/55'>
								Ultima actualizacion: {updatedAt}
							</span>
						</div>

						<h1 className='title-readable mb-4 max-w-3xl font-display text-4xl font-bold text-primary sm:text-5xl'>
							{title}
						</h1>
						<p className='mb-9 max-w-3xl text-base leading-relaxed text-primary/75'>
							{description}
						</p>

						<div className='space-y-5 text-primary/85'>{children}</div>
					</article>
				</div>
			</div>
		</main>
	);
}

export default LegalLayout;
